import React from 'react';

const NeonDivider = ({ color = 'neonBlue' }) => {
  const colorClasses = {
    neonBlue: 'bg-neonBlue shadow-neonBlue',
    neonRed: 'bg-neonRed shadow-neonRed'
  };

  return (
    <div className={`w-full h-px my-8 ${colorClasses[color] || colorClasses.neonBlue}`} />
  );
};

export default NeonDivider; 